import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export interface DigitalServiceResponse {
  serviceName: string;
}

export const getDigitalServices = async (): Promise<DigitalServiceResponse[]> => {
  const response = await axios.get<DigitalServiceResponse[]>(
    `${API_BASE_URL}/DigitalService`
  );
  return response.data;
};
